import { render, staticRenderFns } from "./HistoricalDataCharts.vue?vue&type=template&id=400d9445&scoped=true"
import script from "./HistoricalDataCharts.vue?vue&type=script&lang=js"
export * from "./HistoricalDataCharts.vue?vue&type=script&lang=js"
import style0 from "./HistoricalDataCharts.vue?vue&type=style&index=0&id=400d9445&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d9445",
  null
  
)

export default component.exports